module.exports = __webpack_public_path__ + "static/media/m_w_hr_25.67bdaa7f.png";